/* upload preview button */
$(document).on("click", ".upload_nav_design .preview_btn", function () {
  $("#design-text").val("");
  $(".resizable").css("outline", "unset");
  $(".left_image_customize").addClass("both_active");
  $(".back_image").addClass("active");
  $(".back_image").addClass("active");
  $(".front_image").addClass("active");
  $(".front_tab").addClass("hide");
  $(".back_tab").addClass("hide");
  $(".edit_front_tab").removeClass("hide");
  $(".edit_back_tab").removeClass("hide");
  $(this).addClass("hide");
  $(".upload_nav_design .clear_btn").addClass("hide");
  $(".addtocart_box").removeClass("hide");

  if ($(".selected_design_box.active")[0]) {
    $(".selected_design_box.active .inner_selected_design").css(
      "display",
      "none"
    );
    $(".color_customize_variants").css("display", "none");
  }

  if ($(".inner_logo_designs_content.active")[0]) {
    $(".inner_logo_designs_content.active").css("display", "none");
    $(".color_customize_variants").css("display", "none");
  }

  if ($(".inner_text_design_content.active")[0]) {
    $(".inner_text_design_content.active").css("display", "none");
    $(".color_customize_variants").css("display", "none");
  }

  if ($(".left_image_customize.both_active")[0]) {
    $(".back_image .text_uploaded").removeClass("hide");
    $(".front_image .text_uploaded").removeClass("hide");
    $(".back_image .text_uploaded").addClass("active");
    $(".front_image .text_uploaded").addClass("active");
    var frontimgg = $(".front_image").attr("data-src");
    var backimmg = $(".back_image").attr("data-src");

    $(".front_image img.uploadingimg").attr("src", frontimgg);
    $(".back_image img.uploadingimg").attr("src", backimmg);

    var front_logoimg = $(".front_image .logo_img_gal").attr("src");

    var back_logoimg = $(".back_image .logo_img_gal").attr("src");

    var back = $(".back_image .uploadingimg").attr("src");
    var front = $(".front_image .uploadingimg").attr("src");

    if (back == undefined) {
      console.log("A");

      $(".back_image .resizable").removeClass("active");
    } else {
      $(".back_image .resizable").addClass("active");
    }
    if (front == undefined) {
      console.log("B");
      if ($(".front_image .logo_img.hide")[0]) {
        $(".front_image .text_uploaded").removeClass("hide");
      }
      $(".front_image .resizable").removeClass("active");
      var frontremove = setInterval(function () {
        $(".front_image .resizable").removeClass("active");
        clearInterval(frontremove);
      }, 500);
    } else {
      if ($(".front_image .resizable.hide")[0]) {
        $(".front_image .resizable").removeClass("active");
      } else {
        $(".front_image .resizable").addClass("active");
      }
    }

    if (front_logoimg === undefined || front_logoimg == "") {
      if ($(".front.img_box.active")[0]) {
        console.log("1");
        $(".front_image").addClass("active");
        $(".front_image .resizable").removeClass("hide");

        $(".front_image .resizable").addClass("active");

        $(".front_image .logo_img").addClass("hide");
        $(".front_image .logo_img").removeClass("active");
      }
    }
    console.log("back_img" + back_logoimg);

    /* back edited preview */
    if (back_logoimg === undefined || back_logoimg == "") {
      console.log("2");
      if ($(".back_image.img_box.active")[0]) {
        $(".back_image").addClass("active");
        $(".back_image .resizable").removeClass("hide");
        $(".back_image .resizable").addClass("active");
        $(".back_image .logo_img").addClass("hide");
        $(".back_image .logo_img").removeClass("active");
        $(".back_image .resizable").addClass("active");
        var removea = setInterval(function () {
          if ($(".back_image .resizable.active")[0]) {
            clearInterval(removea);
          } else {
            $(".back_image .resizable").addClass("active");
          }
        }, 1000);
      }
    }

    var front_text = $(".front_image .cstm_textup").html();
    var back_text = $(".front_image .cstm_textup").html();

    /* if logo and text added*/

    if (front_text != "" && front_logoimg != undefined) {
      $(".front_image").addClass("both_textactive");
    } else if (front_text != "" && front != undefined) {
      $(".front_image").addClass("both_textactive");
    } else {
      $(".front_image").removeClass("both_textactive");
    }
    var fronturl = $(".front_image_url").html();
    if (fronturl != "") {
      $(".front_image").addClass("both_textactive");
    } else {
      $("#inverseCheckbox").prop("checked", false);
      $(".front_image").removeClass("both_textactive");
    }

    var backurl = $(".back_image_url").html();
    if (backurl != "") {
      $(".back_image").addClass("both_textactive");
    } else {
      $(".back_image").removeClass("both_textactive");
      $("#backinverseCheckbox").prop("checked", false);
    }
  }
});

/* text preview button*/
$(document).on(
  "click",
  ".nav_design_buttons.text_nav_design .preview_btn",
  function () {
    var currentfont = $(".font_items.active").attr("data-font");
    if ($(".front_text_preview.active")[0]) {
      $(".front_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".front_image").addClass("cstm_font_" + currentfont);
    }
    if ($(".back_text_preview.active")[0]) {
      $(".back_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".back_image").addClass("cstm_font_" + currentfont);
    }

    $(this).addClass("hide");

    $(".left_image_customize").addClass("both_active");
    $(".front_text_preview").removeClass("active");
    $(".front_text_preview").addClass("hide");
    $(".back_text_preview").removeClass("active");
    $(".back_text_preview").addClass("hide");
    $(".front_image").addClass("active");
    $(".front_image").removeClass("hide");
    $(".back_image").addClass("active");
    $(".back_image").removeClass("hide");
    $(".front_image .text_uploaded").removeClass("hide");
    $(".back_image .text_uploaded").removeClass("hide");
    $(".front_tab").addClass("hide");
    $(".back_tab").addClass("hide");
    $(".edit_front_tab").removeClass("hide");
    $(".edit_back_tab").removeClass("hide");
    $(".back_text").css("display", "none");
    $(".text_font_section").css("display", "none");
    $(".text_nav_design .clear_btn").addClass("hide");
    $(".text_nav_design .addtocart_box").removeClass("hide");
    var backhtml = $(".back_image .cstm_textup").html();
    var fronthtml = $(".front_image .cstm_textup").html();
    var logofront = $(".front_image img.logo_img_gal").attr("src");
    var logoback = $(".back_image img.logo_img_gal").attr("src");

    var uploadlogofront = $("#uploaded-image").attr("src");
    var uploadlogoback = $("#buploaded-image").attr("src");
    console.log("logo-f" + logofront);

    if (fronthtml != "") {
      if (logofront === undefined || logofront == "") {
      } else {
        $(".front_image").addClass("both_textactive");
      }
    }
    if (backhtml != "") {
      if (logoback === undefined || logoback == "") {
      } else {
        $(".back_image").addClass("both_textactive");
      }
    }

    if (fronthtml != "" && uploadlogofront != undefined) {
      $(".front_image").addClass("both_textactive");
      console.log("4");
    }

    if (backhtml != "" && uploadlogoback != undefined) {
      $(".back_image").addClass("both_textactive");
      console.log("8");
    }

    if (fronthtml != "") {
      // console.log('1');
      $(".front_image .text_uploaded").removeClass("hide");
      $(".front_image .text_uploaded").addClass("active");
    }

    if (backhtml != "") {
      console.log("2");
      $(".back_image .text_uploaded").removeClass("hide");
      $(".back_image .text_uploaded").addClass("active");
    }
    /* back product image logo*/
    /* when logo not selected*/
    if (logoback == "" || logoback == undefined) {
      $(".back_image .resizable").removeClass("hide");
      $(".back_image .resizable").addClass("active");
      $(".back_image .logo_img").addClass("hide");
      $(".back_image .logo_img").removeClass("active");
      $(".back_image .text_uploaded").removeClass("hide");
      $(".back_image .text_uploaded").addClass("active");
    } else {
      /* when logo selected */
      $(".back_image .resizable").removeClass("active");
      $(".back_image .resizable").addClass("hide");
      $(".back_image .logo_img").addClass("active");
      $(".back_image .logo_img").removeClass("hide");
      $(".back_image .text_uploaded").removeClass("hide");
      $(".back_image .text_uploaded").addClass("active");
    }

    /* front logo image*/
    if (logofront == "" || logofront == undefined) {
      $(".front_image .resizable").removeClass("hide");
      $(".front_image .resizable").addClass("active");
      $(".front_image .logo_img").addClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .text_uploaded").removeClass("hide");
      $(".front_image .text_uploaded").addClass("active");
    } else {
      $(".front_image .resizable").removeClass("active");
      $(".front_image .resizable").addClass("hide");
      $(".front_image .logo_img").addClass("active");
      $(".front_image .logo_img").removeClass("hide");
      $(".front_image .text_uploaded").removeClass("hide");
      $(".front_image .text_uploaded").addClass("active");
    }

    var fronturl = $(".front_image_url").html();
    if (fronturl != "") {
      $(".front_image").addClass("both_textactive");
    } else {
      $("#inverseCheckbox").prop("checked", false);
      $(".front_image").removeClass("both_textactive");
    }

    var backurl = $(".back_image_url").html();
    if (backurl != "") {
      $(".back_image").addClass("both_textactive");
    } else {
      $(".back_image").removeClass("both_textactive");
      $("#backinverseCheckbox").prop("checked", false);
    }

    var front_size = $(".front_image").attr("data-size");
    var back_size = $(".back_image").attr("data-size");
    $(".front_image").removeClass(
      "cstm_size_0 cstm_size_1 cstm_size_2 cstm_size_3 cstm_size_4 cstm_size_5 cstm_size_6 cstm_size_7 cstm_size_8 cstm_size_9 cstm_size_10 cstm_size_11 cstm_size_12"
    );
    $(".back_image").removeClass(
      "cstm_size_0 cstm_size_1 cstm_size_2 cstm_size_3 cstm_size_4 cstm_size_5 cstm_size_6 cstm_size_7 cstm_size_8 cstm_size_9 cstm_size_10 cstm_size_11 cstm_size_12"
    );
    $(".front_image").addClass("cstm_size_" + front_size);
    $(".back_image").addClass("cstm_size_" + back_size);
  }
);

/* gallery preview buttons */

$(document).on("click", ".gallery_nav_design .preview_btn", function () {
  // $('.color_customize_variants').css('display','block');
  $(this).addClass("hide");
  $(".inner_gallerry_wraper.animal_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.sports_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.line_gallery").removeClass("hide");
   $(".inner_gallerry_wraper.nature_gallery").removeClass("hide");
  $(".inner_gallerry_wraper.travel_gallery").removeClass("hide");

  
  $(".back_logo.back_btn").removeClass("hide");
  $(".back_animal.back_inner").addClass("hide");
  $(".back_sports.back_inner").addClass("hide");
  $(".back_lineart.back_inner").addClass("hide");
   $(".back_nature.back_inner").addClass("hide");
   $(".back_nature_travel.back_inner").addClass("hide");
  $(".left_image_customize").addClass("both_active");
  $(".back_image").addClass("active");
  $(".front_image").addClass("active");
  $(".front_tab").addClass("hide");
  $(".back_tab").addClass("hide");
  $(".edit_front_tab").removeClass("hide");
  $(".edit_back_tab").removeClass("hide");
  $(".back_logo").css("display", "flex");
  $(".logos_content").css("display", "none");
  $(".logo_gallery").css("display", "none");
  // $('.color_customize_variants').css('display','none');
  $(".gallery_nav_design .clear_btn").addClass("hide");
  $(".gallery_nav_design .addtocart_box").removeClass("hide");

  var galtextback = $(".back_image .cstm_textup").html();
  var galtextfront = $(".front_image .cstm_textup").html();

  var logoafront = $(".front_image img.logo_img_gal").attr("src");
  var logoaback = $(".back_image img.logo_img_gal").attr("src");

  if (galtextfront != "" && logoafront != undefined) {
    $(".front_image").addClass("both_textactive");
    console.log("4");
  }

  if (galtextback != "" && logoaback != undefined) {
    $(".back_image").addClass("both_textactive");
    console.log("4");
  }

  if (backhtml != "" && uploadlogoback != undefined) {
    $(".back_image").addClass("both_textactive");
    console.log("8");
  }

  if (fronthtml1 != "") {
    $(".front_image .text_uploaded").removeClass("hide");
    $(".front_image .text_uploaded").addClass("active");
    // $('.front_image').addClass('both_textactive');
  }

  if (backhtml1 != "") {
    $(".back_image .text_uploaded").removeClass("hide");
    $(".back_image .text_uploaded").addClass("active");
    // $('.back_image').addClass('both_textactive');
  }

  var logoback1 = $(".back_image img.logo_img_gal").attr("src");

  if (logoback1 == "" || logoback1 == undefined) {
    $(".back_image .resizable").removeClass("hide");
    $(".back_image .resizable").addClass("active");
    $(".back_image .logo_img").addClass("hide");
    $(".back_image .logo_img").removeClass("active");
    $(".back_image .text_uploaded").removeClass("hide");
    $(".back_image .text_uploaded").addClass("active");
  } else {
    /* when logo selected */
    $(".back_image .resizable").removeClass("active");
    $(".back_image .resizable").addClass("hide");
    $(".back_image .logo_img").addClass("active");
    $(".back_image .logo_img").removeClass("hide");
    $(".back_image .text_uploaded").removeClass("hide");
    $(".back_image .text_uploaded").addClass("active");
  }
  var logofront1 = $(".front_image img.logo_img_gal").attr("src");
  /* front logo image*/
  if (logofront1 == "" || logofront1 == undefined) {
    $(".front_image .resizable").removeClass("hide");
    $(".front_image .resizable").addClass("active");
    $(".front_image .logo_img").addClass("hide");
    $(".front_image .logo_img").removeClass("active");
    $(".front_image .text_uploaded").removeClass("hide");
    $(".front_image .text_uploaded").addClass("active");
  } else {
    $(".front_image .resizable").removeClass("active");
    $(".front_image .resizable").addClass("hide");
    $(".front_image .logo_img").addClass("active");
    $(".front_image .logo_img").removeClass("hide");
    $(".front_image .text_uploaded").removeClass("hide");
    $(".front_image .text_uploaded").addClass("active");
  }
});

/* input type search*/
$(document).ready(function () {
  $("input.animal_search").bind("keyup change", function () {
    if ($(this).val().trim().length !== 0) {
      $(".animal .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          if ($(this).is(":icontains(" + $("input.animal_search").val() + ")"))
            $(this).show();
        });
    } else {
      $(".animal .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          $(this).show();
        });
    }
  });
  $("input.sports_search").bind("keyup change", function () {
    if ($(this).val().trim().length !== 0) {
      $(".sports .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          if ($(this).is(":icontains(" + $("input.sports_search").val() + ")"))
            $(this).show();
        });
    } else {
      $(".sports .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          $(this).show();
        });
    }
  });

   $("input.line_search").bind("keyup change", function () {
    if ($(this).val().trim().length !== 0) {
      $(".line .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          if ($(this).is(":icontains(" + $("input.line_search").val() + ")"))
            $(this).show();
        });
    } else {
      $(".line .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          $(this).show();
        });
    }
  });

     $("input.nature_search").bind("keyup change", function () {
    if ($(this).val().trim().length !== 0) {
      $(".nature .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          if ($(this).is(":icontains(" + $("input.nature_search").val() + ")"))
            $(this).show();
        });
    } else {
      $(".nature .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          $(this).show();
        });
    }
  });
  
     $("input.travel_search").bind("keyup change", function () {
    if ($(this).val().trim().length !== 0) {
      $(".travel .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          if ($(this).is(":icontains(" + $("input.travel_search").val() + ")"))
            $(this).show();
        });
    } else {
      $(".travel .logo-item-detail")
        .show()
        .hide()
        .each(function () {
          $(this).show();
        });
    }
  });

  $.expr[":"].icontains = function (obj, index, meta, stack) {
    return (
      (obj.textContent || obj.innerText || jQuery(obj).text() || "")
        .toLowerCase()
        .indexOf(meta[3].toLowerCase()) >= 0
    );
  };
});
